export const environment = {
  apiUrl: 'https://vaultrix-webapp.onrender.com/api'
};
